<template>
  <div>
    <div style="text-transform: uppercase; line-height: 15px" class="p-2">
      <br />
      <label>{{ leilao.cidade }} / {{ leilao.estado }}</label>
      <p style="line-height: 23px">
        {{ leilao.leilao_titulo }}
        <br />
        {{ leilao.leilao_descricao }}
        <br />
        <a @click="getUrlLeilao()" href="#">Site</a>
      </p>
      <!-- DATAS E VALORES DOS LEILÕES -->
      <div v-if="leilao.leilao_num_pracas > 1" style="border-bottom: none; text-align: left; line-height: 23px; margin-top: 8px">
        <br />
        <div style="font-size: 18px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
          <b>1º Leilão:</b>
          {{ formatDate(leilao.leilao_1_data) + "h" }}
        </div>

        <!-- DATA 2 -->
        <div style="font-size: 18px" v-if="leilao.leilao_num_pracas >= 2">
          <b>2º Leilão:</b>
          {{ formatDate(leilao.leilao_2_data) + "h" }}
        </div>

        <div style="font-size: 18px" v-else><br /></div>

        <!-- DATA 3 -->
        <div style="font-size: 18px" v-if="leilao.leilao_num_pracas >= 3">
          <b>3º Leilão:</b>
          {{ formatDate(leilao.leilao_3_data) + "h" }}
        </div>

        <!-- DATA 4 -->
        <div style="font-size: 18px" v-if="leilao.leilao_num_pracas >= 4">
          <b>4º Leilão:</b>
          {{ formatDate(leilao.leilao_4_data) + "h" }}
        </div>
      </div>

      <!-- ÚNICO LEILÃO-->
      <div v-else-if="leilao.leilao_num_pracas == 1" style="border-bottom: none; text-align: left; line-height: 20px; margin-top: 8px">
        <div style="font-size: 18px; margin-bottom: 3px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
          <b>Único leilão:</b>
          {{ formatDate(leilao.leilao_1_data) + "h" }}
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <button style="float: left; margin-top: -5px" type="button" class="btn btn-tool" data-toggle="collapse" href="#collapse1">
          <i class="fas fa-minus"></i>
        </button>
        <h5 class="card-title" id="accordion">Filtrar lotes</h5>
      </div>
      <div id="collapse1" class="collapse" data-parent="#accordion">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-2">
              <div class="form-group">
                <label for="nome">Número lote</label>
                <input @keyup="buscarLotes" class="form-control" id="id" v-model="numero" />
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label for="endereco_estado">UF</label>

                <select class="custom-select rounded-0" id="endereco_estado" v-model="estado" @change="buscarCidades()">
                  <option value=""></option>
                  <option v-for="estado in estados" :key="estado" :value="estado.id">
                    {{ estado.nome }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="cidade" @change="buscarLotes">
                  <option v-for="cidade in cidades" :key="cidade" :value="cidade.id">
                    {{ cidade.nome }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="comitente">TÍtulo</label>
                <input @keyup="buscarLotes" class="form-control" placeholder="" v-model="titulo" />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="cpf_cnpj">Descrição</label>
                <input @keyup="buscarLotes" class="form-control" placeholder="" v-model="descricao" />
              </div>
            </div>
            <div class="col-sm-12">
              <button class="btn btn-default btn-sm" @click="limparFiltros">Limpar filtros</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TABELA DE LOTES -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Lotes</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th style="width: 40% !important">Informações</th>
              <th>Lance</th>
              <th>Status</th>
              <th>--</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(lote, index) in lotes" :key="lote" @contextmenu.prevent="onRightClick($event, lote)" @click="hideMenu()">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Id">
                <span class="right badge badge-secondary" v-if="!lote.edit">
                  <i class="fa fa-pen" @click="(lote.edit = true), (lote.numero_edit = lote.lote_numero)" style="cursor: pointer"></i>
                  Lote {{ lote.lote_numero }}
                </span>

                <form v-on:submit.prevent="editarNumeroLote(lote)" v-if="lote.edit">
                  <div class="input-group">
                    <div class="input-group input-group-sm">
                      <input
                        style="width: 50%; max-width: 70px; font-size: 15px; max-height: 26px"
                        type="text"
                        class="form-control"
                        v-model="lote.numero_edit"
                        @click="lote.edit = true"
                      />

                      <span class="input-group-append">
                        <button style="max-height: 26px" @click="editarNumeroLote(lote)" type="button" class="btn btn-info btn-flat">
                          <i class="fa fa-check"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </form>
                &nbsp;
                <a :href="'/admin/leilao/' + leilao.id">
                  <i class="fa fa-pen"></i>
                  {{ lote.id }} &nbsp;
                </a>
                <br />
                <a :href="'/lote/' + lote.id" target="_blank">Site</a>
                <br />
                <strong>{{ lote.lote_titulo }}</strong>
                <br />
                Avaliação: R$ {{ toCurrency(lote.lote_avaliacao) }}
                <div>1. Leilão: R$ {{ toCurrency(lote.lote_valor_1) }}</div>
                <div v-if="leilao.leilao_num_pracas >= 2">2. Leilão: R$ {{ toCurrency(lote.lote_valor_2) }}</div>
                <div v-if="leilao.leilao_num_pracas >= 3">3. Leilão: R$ {{ toCurrency(lote.lote_valor_3) }}</div>
                <div v-if="leilao.leilao_num_pracas >= 4">4. Leilão: R$ {{ toCurrency(lote.lote_valor_4) }}</div>
                <div>
                  <span class="right badge badge-secondary">{{ lote.lote_visits }}</span>
                  visitas

                  <span class="right badge badge-secondary" v-if="lote.lote_nf">NF {{ lote.lote_nf }}</span>
                </div>

                <!--
                <div style="margin-top: 5px">
                  <a style="margin-left: 5px" :href="'/lote/' + lote.id" target="_blank">
                    <i class="fas fa-eye"></i>
                    Visualizar no site
                  </a>
                </div>
                -->
              </td>

              <td data-label="Informações">
                <a>Maior lance: R$ {{ toCurrency(lote.lote_lance) }}</a>
                <br />
                <a v-if="lote.user">
                  Apelido:&nbsp;

                  <a :href="'/admin/cadastros/detalhes/' + lote.user.id">{{ lote.user.apelido }}</a>

                  <!-- <span style="text-transform: uppercase">{{ lote.user.apelido }}</span> -->
                </a>
                <br />
                <a>Comissão: {{ toCurrency(lote.lote_comissao) }}%</a>
                <br />
                <a>ICMS: {{ toCurrency(lote.lote_icms) }}%</a>
                <br />
                <!--
                <a>{{ lote.cidade }} /{{ lote.estado }}</a>
                <br />
                -->
              </td>

              <td data-label="Atualizações">
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="ativo" v-model="lote.status_temp" @change="alterarStatusLote(lote)" />
                  <label class="form-check-label">Em leilão</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="vendido" v-model="lote.status_temp" @change="alterarStatusLote(lote)" />
                  <label class="form-check-label">Vendido</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="retirado" v-model="lote.status_temp" @change="alterarStatusLote(lote)" />
                  <label class="form-check-label">Retirado</label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="vendido_condicional"
                    v-model="lote.status_temp"
                    @change="alterarStatusLote(lote)"
                  />
                  <label class="form-check-label">Venda condicional</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="sem_licitante" v-model="lote.status_temp" @change="alterarStatusLote(lote)" />
                  <label class="form-check-label">Sem licitante</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="suspenso" v-model="lote.status_temp" @change="alterarStatusLote(lote)" />
                  <label class="form-check-label">Suspenso</label>
                </div>
                <input type="checkbox" id="agreeTerms" name="terms" value="agree" v-model="lote.lote_oculto" @change="changeStatus(lote)" />
                &nbsp;&nbsp; Oculto
              </td>

              <td data-label="Atualizações">
                Criado há:
                <strong>{{ calcularValor(lote.created_at) }}</strong>
                <br />
                Atualizado há:
                <strong>{{ calcularValor(lote.updated_at) }}</strong>
                <br />

                <a :href="getUrlFotos(lote)">
                  <span class="right badge badge-secondary" :class="lote.hasFotos ? 'badge-success' : 'span-gray'">Fotos</span>
                </a>
                <a :href="getUrlDocumentos(lote)">
                  <span style="margin-left: 5px" class="right badge badge-secondary" :class="lote.hasDocuments ? 'badge-success' : 'span-gray'">
                    Docs
                  </span>
                </a>
                <span style="margin-left: 5px" class="right badge badge-secondary" :class="lote.hasEdital ? 'badge-success' : 'span-gray'">
                  Edital
                </span>
              </td>
              <td>
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div id="meu_menu" class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>

                  <a :href="getUrlEdit(lote)" class="dropdown-item">
                    <i class="fa-solid fa-pen"></i>
                    &nbsp;&nbsp; Editar
                  </a>

                  <div class="dropdown-divider"></div>
                  <a :href="getUrlFotos(lote)" class="dropdown-item">
                    <i class="fa-solid fa-image"></i>
                    &nbsp;&nbsp; Fotos
                  </a>

                  <div class="dropdown-divider"></div>
                  <a
                    @click="(gerar_documento = true), (lote_selecionado = lote)"
                    class="dropdown-item"
                    data-toggle="modal"
                    data-target="#gerar-documento-modal"
                    style="cursor: pointer"
                  >
                    <i class="fa-regular fa-file"></i>
                    &nbsp;&nbsp; Gerador de documentos
                  </a>

                  <div class="dropdown-divider"></div>
                  <a :href="getUrlLogs(lote)" class="dropdown-item">
                    <i class="fa-solid fa-book"></i>
                    &nbsp;&nbsp; Logs
                  </a>
                  <div class="dropdown-divider"></div>
                  <a href="#" @click="validarExcluirLote(lote)" class="dropdown-item">
                    <i class="fa-solid fa-trash"></i>
                    &nbsp;&nbsp; Excluir
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div
          id="newMenu"
          class="dropdown-menu-lg dropdown-menu-right"
          style="position: absolute; background-color: white; max-width: 300px; line-height: 15px; visibility: hidden"
        >
          <div class="dropdown-divider"></div>

          <a class="dropdown-item" :href="getUrlEdit()">
            <i class="fa-solid fa-pen"></i>
            &nbsp;&nbsp; Editar
          </a>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" :href="getUrlFotos()">
            <i class="fa-solid fa-image"></i>
            &nbsp;&nbsp; Fotos
          </a>
          <div class="dropdown-divider"></div>
          <a @click="gerar_documento = true" style="cursor: pointer" class="dropdown-item" data-toggle="modal" data-target="#gerar-documento-modal">
            <i class="fa-regular fa-file"></i>
            &nbsp;&nbsp; Gerador de documentos
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" :href="getUrlLogs()">
            <i class="fa-solid fa-book"></i>
            &nbsp;&nbsp; Logs
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" @click="validarExcluirLote(lote_selecionado)" class="dropdown-item">
            <i class="fa-solid fa-trash"></i>
            &nbsp;&nbsp; Excluir
          </a>
        </div>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + lotes.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>

    <!-- MODAL -->
    <div
      class="modal fade"
      id="visualizar-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Visualizar leilão</h4>
              <br />
              <div class="card card-primary">
                <div class="card-header">
                  <h3 class="card-title" style="color: white">Visualizar leilão</h3>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- ATIVAR REGRESSIVA -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="leilao_acionar_regressiva_apos">Ativar regressiva faltando (s)</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_acionar_regressiva_apos"
                          placeholder="Tempo em segundos"
                          v-model="leilao_selecionado.leilao_acionar_regressiva_apos"
                        />
                      </div>
                    </div>

                    <!-- REINICIAR TEMPO -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="leilao_regressiva">Reiniciar o tempo em (s)</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_regressiva"
                          placeholder="Tempo em segundos"
                          v-model="leilao_selecionado.leilao_regressiva"
                        />
                      </div>
                    </div>

                    <!-- INTERVALO -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="leilao_lote_intervalo">Intervalo entre os lotes (s)</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_lote_intervalo"
                          placeholder="Tempo em segundos"
                          v-model="leilao_selecionado.leilao_lote_intervalo"
                        />
                      </div>
                    </div>

                    <!-- TEMPO PRIMEIRO LOTE -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="leilao_primeiro_lote_margem_tempo">Primeiro lote inicia com (s)</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_primeiro_lote_margem_tempo"
                          placeholder="Tempo em segundos"
                          v-model="leilao_selecionado.leilao_primeiro_lote_margem_tempo"
                        />
                      </div>
                    </div>

                    <!-- LEILOEIRO RESPONSÁVEL -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="endereco_cidade">Leiloeiro responsável</label>
                        <label for="endereco_cidade" class="form-control">
                          {{ leilao_selecionado.leiloeiro_matricula + "- " + leilao_selecionado.leiloeiro }}
                        </label>
                      </div>
                    </div>

                    <!-- TAXA -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_taxa_administrativa">Taxa administrativa</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_taxa_administrativa"
                          placeholder="0.00"
                          v-model="leilao_selecionado.leilao_taxa_administrativa"
                          type="number"
                          step="0.01"
                        />
                      </div>
                    </div>

                    <!-- ENDERECO ESTADO -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="endereco_estado">UF</label>

                        <label for="endereco_cidade" class="form-control">
                          {{ leilao_selecionado.estado }}
                        </label>
                      </div>
                    </div>

                    <!-- ENDERECO CIDADE -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="endereco_cidade">Cidade</label>

                        <label for="endereco_cidade" class="form-control">
                          {{ leilao_selecionado.cidade }}
                        </label>
                      </div>
                    </div>

                    <!-- COMITENTE -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="comitente">Comitente</label>
                        <label for="comitente" class="form-control">
                          {{ leilao_selecionado.comitente }}
                        </label>
                      </div>
                    </div>

                    <!-- MODO GENÉRICO -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_modo_generico">Modo genérico</label>

                        <label for="leilao_modo_generico" class="form-control">
                          {{ convertTiny(leilao_selecionado.leilao_modo_generico) }}
                        </label>
                      </div>
                    </div>

                    <!-- TITULO -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_titulo">Título</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_titulo"
                          placeholder="Título"
                          v-model="leilao_selecionado.leilao_titulo"
                        />
                      </div>
                    </div>

                    <!-- DESCRIÇÃO -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_descricao">Descrição</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_descricao"
                          placeholder="Título"
                          v-model="leilao_selecionado.leilao_descricao"
                        />
                      </div>
                    </div>

                    <!-- LOCAL DO LEILÃO -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_local">Local do leilão</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_local"
                          placeholder="Título"
                          v-model="leilao_selecionado.leilao_local"
                        />
                      </div>
                    </div>

                    <!-- TIPO lote -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_tipo">Tipo do leilão</label>

                        <input disabled="true" class="form-control" id="leilao_tipo" placeholder="Título" v-model="leilao_selecionado.leilao_tipo" />
                      </div>
                    </div>

                    <!-- NÚMERO DE PRAÇAS -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="leilao_num_pracas">Número de praças</label>
                        <input
                          disabled="true"
                          class="form-control"
                          id="leilao_num_pracas"
                          placeholder="Título"
                          v-model="leilao_selecionado.leilao_num_pracas"
                        />
                      </div>
                    </div>

                    <!-- INFORMAÇÕES GERAIS -->
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label for="leilao_info_geral">Informações gerais</label>
                        <br />
                        <div for="leilao_num_pracas" v-html="leilao_selecionado.leilao_info_geral"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <button data-toggle="modal" id="cancelar" data-target="#visualizar-modal" class="btn btn-danger">Fechar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <admin-gerar-documentos v-if="gerar_documento" :leilao="leilao" :lote_id="lote_selecionado.id" :setGerarDocumento="setGerarDocumento" />
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import currencyController from "../../controller/currencyController";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import InputMask from "primevue/inputmask";

import ContextMenu from "primevue/contextmenu";

export default {
  props: ["estados", "leilao"],

  mixins: [sweetAlert, Swal, AuxController, currencyController],

  components: { Loading, ContextMenu, InputMask },

  data() {
    return {
      gerar_documento: false,
      isLoading: false,
      leilao_selecionado: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      lotes: [],
      cidades: [],
      numero: "",
      estado: "",
      cidade: "",
      titulo: "",
      descricao: "",
      lotes: [],
      lote_selecionado: "",
      items: [
        {
          label: "Editar",
          icon: "fa-solid fa-pen",
          command: () => {
            this.command();
          },
          class: "dropdown-item",
        },
        {
          label: "Add",
          icon: "pi pi-shopping-cart",
          class: "dropdown-item",
        },
        {
          separator: true,
        },
      ],
    };
  },

  mounted() {
    console.log(this.leilao);
    this.buscarLotes();
  },

  methods: {
    forceDisconnect() {
      let data = {
        leilao_id: this.leilao.id,
      };

      axios.post(process.env.MIX_VUE_APP_AUDITORIO + `/emit_disconnect`, data).then((response) => {});
    },

    validarExcluirLote(lote) {
      console.log("V1");
      console.log(lote);

      this.lote_selecionado = lote;

      let data = {
        id: this.lote_selecionado.id,
      };

      console.log("Validando");
      console.log(data);

      axios
        .post(`/admin/delete_lote/validate`, data)
        .then((response) => {
          console.log("Resposta");
          console.log(response);

          if (response.data.success) {
            let html =
              "Deseja apagar o Lote " +
              this.lote_selecionado.lote_numero +
              " do Leilão ID " +
              this.lote_selecionado.leilao_id +
              "? Essa ação é irreversível.";

            this.$swal
              .fire({
                title: "Confirmação",
                html: html,
                icon: "warning",
                padding: "1.5em",
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, quero deletar!",
              })
              .then((result) => {
                if (result.value) {
                  this.isLoading = true;

                  let data = {
                    id: this.lote_selecionado.id,
                    pergunta: html,
                  };

                  axios
                    .post(`/admin/delete_lote/delete`, data)
                    .then((response) => {
                      this.showSuccessMessage("Lote deletado com sucesso!");
                      this.buscarLotes();
                    })
                    .catch((error) => {
                      this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                      console.log(error.response.data);
                    });
                }
              });
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getUrlLeilao() {
      let qtd_lotes_nao_ocultos = 0;
      let lote_disponivel_id = null;

      for (let i = 0; i < this.lotes.length; i++) {
        if (this.lotes[i].lote_oculto == 0) {
          qtd_lotes_nao_ocultos++;

          if (!lote_disponivel_id) {
            lote_disponivel_id = this.lotes[i].id;
          }
        }
      }

      if (qtd_lotes_nao_ocultos > 1) {
        window.open("/leilao/" + this.leilao.id + "/lotes");
      } else {
        if (lote_disponivel_id) {
          window.open("/lote/" + lote_disponivel_id);
        } else {
          this.showErrorMessageWithButton("Ops...", "Este leilão não possui nenhum lote disponível para visualização.");
        }
      }
    },

    setGerarDocumento(value) {
      this.gerar_documento = value;
      console.log("Setando gerar documento");
      this.buscarLotes();
    },

    changeStatus(lote) {
      console.log(lote);

      let data = {
        lote_id: lote.id,
        lote_oculto: this.convertToTiny(lote.lote_oculto),
      };

      console.log(data);

      axios
        .post(`/admin/lote/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");

          this.forceDisconnect();

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    editarNumeroLote(lote) {
      console.log("Editando lote " + lote);
      lote.edit = false;

      let data = {
        lote_id: lote.id,
        leilao_id: lote.leilao_id,
        lote_numero: lote.numero_edit,
      };

      axios
        .post(`/admin/lote/update_lote_numero`, data)
        .then((response) => {
          if (response.data.success) {
            this.showSuccessMessage("Número atualizado");

            lote.lote_numero = lote.numero_edit;
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, lote) {
      console.log("Lote selecionado");
      this.lote_selecionado = lote;
      //console.log(this.$refs.right_menu);

      //this.$refs.right_menu.show(event);

      let newMenu = document.getElementById("newMenu");

      let x = event.clientX - 300;
      let y = event.pageY - 350;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    command() {},

    alterarStatusLote(lote) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja alterar o status do lote <br/><b>" + lote.lote_numero + "</b> ?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero alterar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              lote_id: lote.id,
              lote_status: lote.status_temp,
            };

            axios
              .post(`/admin/lote/atualizar_status`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessageWithButton("Status atualizado!");

                this.forceDisconnect();
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error);
                console.log(error);
              });
          } else {
            lote.status_temp = lote.lote_status;
          }
        });
    },

    getUrlAddLote(lote) {
      return "/admin/lote/" + lote.id + "/lotes/cadastrar_lote";
    },

    getUrlDocumentos(lote) {
      return "/admin/documentos/" + lote.leilao_id;
    },

    getUrlLogs(lote) {
      let id = lote ? lote.id : this.lote_selecionado.id;

      return "/admin/lote/" + id + "/logs";
    },

    limparFiltros() {
      this.numero = "";
      this.descricao = "";
      this.titulo = "";
      this.leilao_id = "";
      this.cidade = "";
      this.estado = "";

      this.buscarLotes();
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    visualizar(lote) {
      this.leilao_selecionado = lote;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    getUrlEdit(lote) {
      let id = lote ? lote.id : this.lote_selecionado.id;

      return "/admin/leilao/" + this.leilao.id + "/lotes/editar/" + id;
    },

    show(lote) {
      this.leilao_selecionado = lote;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLotes();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLotes();
      }
    },

    getUrlFotos(lote) {
      let id = lote ? lote.id : this.lote_selecionado.id;

      return "/admin/fotos/" + id + "";
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          console.log(response.data);

          this.isLoading = false;

          this.buscarLotes();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarLotes() {
      this.isLoading = true;

      let data = {
        numero: this.numero,
        titulo: this.titulo,
        descricao: this.descricao,
        leilao_id: this.leilao.id,
        estado_id: this.estado,
        cidade_id: this.cidade,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        order_by_number: true,
      };

      console.log(data);

      axios
        .post(`/admin/lote/search`, data)
        .then((response) => {
          this.lotes = response.data.lotes;
          this.total = response.data.total;

          if (this.lotes && this.lotes.length > 0) {
            for (let i = 0; i < this.lotes.length; i++) {
              this.lotes[i].status_temp = this.lotes[i].lote_status;

              console.log(this.lotes[i].id);
              console.log(this.lotes[i].lote_oculto);

              if (this.lotes[i].lote_oculto == 1) {
                this.lotes[i].lote_oculto = true;
              } else {
                this.lotes[i].lote_oculto = false;
              }
            }
          }

          console.log("Lotes");
          console.log(this.lotes);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLotes();
    },

    deletar(lote) {
      this.leilao_selecionado = lote;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de lote<b><br/>" + this.leilao_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.leilao_selecionado.id,
            };

            axios
              .post(`/admin/lote/delete`, data)
              .then((response) => {
                this.showSuccessMessage("lote deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.leilao_selecionado.id,
        cadastro_tipo: this.leilao_selecionado.cadastro_tipo,
        tipodoc: this.leilao_selecionado.tipodoc,
        estado_civil: this.leilao_selecionado.estado_civil,
        obrigatorio: this.leilao_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.span-green {
  background-color: green;
}

.span-grwy {
  background-color: gray;
}

.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}

.realizado {
  text-decoration: line-through;
}
</style>
